export const isEmpty = (val: any) => {
  return val === null || val === undefined;
};

export const loadJS = (url: string) => {
  if (!url) {
    return Promise.reject();
  }
  return new Promise((resolve, reject) => {
    const ele = document.createElement('script');
    ele.src = url;
    ele.onload = () => resolve();
    ele.onerror = () => reject();
    document.head.appendChild(ele);
  });
};